import React from 'react';
import {routeName} from '../../../src/Service/env'
import logo from "../../images/logo.png";
import './logo.css';

const Logo=()=>(
    <img src={logo} alt="logo" className="logo" onClick={()=>{
        window.location=`/${routeName}`;
    }} />
);
export default Logo;